module.exports = __webpack_public_path__ + "img/9.120.0-2.4526abf0.png";